package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.AppTheme
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_plus_24

@Composable
fun AppOutlinedChip(
    text: String,
    iconRes: DrawableResource? = null,
    disabled: Boolean = false,
) {
    val backgroundColor = if (disabled) {
        MaterialTheme.colors.outlinedChipsBackgroundDisabled
    } else {
        MaterialTheme.colors.outlinedChipsBackgroundEnabled
    }
    val contentColor = if (disabled) {
        MaterialTheme.colors.outlinedChipsContentDisabled
    } else {
        MaterialTheme.colors.outlinedChipsContentEnabled
    }
    val outlineColor = if (disabled) {
        MaterialTheme.colors.outlinedChipsOutlineDisabled
    } else {
        MaterialTheme.colors.outlinedChipsOutlineEnabled
    }

    Box(
        modifier = Modifier
            .border(
                border = BorderStroke(
                    width = 1.dp,
                    color = outlineColor
                ),
                shape = RoundedCornerShape(8.dp)
            )
            .background(
                color = backgroundColor,
            )
            .padding(
                start = if (iconRes != null) 8.dp else 16.dp,
                end = 16.dp,
                top = 8.dp,
                bottom = 8.dp,
            )
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {
            iconRes?.let {
                Icon(
                    painter = painterResource(iconRes),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp),
                    tint = contentColor,
                )
                AppSpacer(6.dp)
            }
            Text(
                text = text,
                color = contentColor,
                style = AppTextStyles.labelMediumMedium
            )
        }
    }
}

private val Colors.outlinedChipsContentEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

private val Colors.outlinedChipsContentDisabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight400 else AppColors.grayDark500

private val Colors.outlinedChipsBackgroundEnabled: Color
    @Composable
    get() = AppColors.transparent

private val Colors.outlinedChipsBackgroundDisabled: Color
    @Composable
    get() = AppColors.transparent

private val Colors.outlinedChipsOutlineEnabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight300 else AppColors.grayDark600

private val Colors.outlinedChipsOutlineDisabled: Color
    @Composable
    get() = if (isLight) AppColors.grayLight200 else AppColors.grayDark700


@Preview
@Composable
fun AppOutlinedChipPreview() {
    Column {
        Row {
            Column(
                modifier = Modifier
                    .background(Color.White)
                    .padding(16.dp)
            ) {

                AppTheme(isDarkTheme = false) {

                    // Outlined enabled

                    AppOutlinedChip(
                        text = "Enabled",
                    )
                    AppSpacer(16.dp)
                    AppOutlinedChip(
                        text = "Enabled",
                        iconRes = Res.drawable.ic_plus_24
                    )
                    AppSpacer(16.dp)

                    // Outlined disabled

                    AppOutlinedChip(
                        text = "Disabled",
                        disabled = true,
                    )
                    AppSpacer(16.dp)
                    AppOutlinedChip(
                        text = "Disabled",
                        iconRes = Res.drawable.ic_plus_24,
                        disabled = true,
                    )
                }
            }
            Column(
                modifier = Modifier
                    .background(Color.Black)
                    .padding(16.dp)
            ) {

                AppTheme(isDarkTheme = true) {

                    // Outlined enabled

                    AppOutlinedChip(
                        text = "Enabled",
                    )
                    AppSpacer(16.dp)
                    AppOutlinedChip(
                        text = "Enabled",
                        iconRes = Res.drawable.ic_plus_24
                    )
                    AppSpacer(16.dp)

                    // Outlined disabled

                    AppOutlinedChip(
                        text = "Disabled",
                        disabled = true,
                    )
                    AppSpacer(16.dp)
                    AppOutlinedChip(
                        text = "Disabled",
                        iconRes = Res.drawable.ic_plus_24,
                        disabled = true,
                    )
                }
            }
        }
    }
}